export default "__VITE_ASSET__MH6PiTcN__"